export interface ICourse {
  code: string;
  description: string;
  area: string;
}

export enum CourseArea {
  management = 'Gestión y mejora',
  metrology = 'Metrología',
  humanResources = 'Recursos humanos'
}
